<template>
  <div class="app-container">
    <div class="toolbar">
      <el-button size="small" type="primary" @click="loadDevices">Refresh</el-button>
    </div>

    <el-table :data="devices" border>
      <el-table-column prop="deviceId" label="Device" min-width="180" />
      <el-table-column prop="status" label="Status" width="150" />
      <el-table-column prop="appVersion" label="App Version" width="130" />
      <el-table-column prop="batteryPercent" label="Battery" width="100" />
      <el-table-column prop="currentTaskId" label="Current Task" width="130" />
      <el-table-column prop="revoked" label="Revoked" width="100" />
      <el-table-column prop="registeredAt" label="Registered" width="180" />
      <el-table-column prop="lastHeartbeatAt" label="Last Heartbeat" width="180" />
      <el-table-column prop="lastError" label="Last Error" min-width="260" />
      <el-table-column label="Action" width="150">
        <template slot-scope="{ row }">
          <el-button v-if="!row.revoked" size="mini" type="danger" @click="revoke(row)"
            >Revoke</el-button
          >
          <el-button v-else size="mini" type="success" @click="enable(row)">Enable</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      devices: [],
    };
  },
  created() {
    this.loadDevices();
  },
  methods: {
    async loadDevices() {
      const data = await this.axios.get("mall:/api/admin/sourcing/devices");
      this.devices = data.content || data.items || [];
    },
    async revoke(row) {
      await this.axios.post(`mall:/api/admin/sourcing/devices/${row.id}/revoke`);
      await this.loadDevices();
    },
    async enable(row) {
      await this.axios.post(`mall:/api/admin/sourcing/devices/${row.id}/enable`);
      await this.loadDevices();
    },
  },
};
</script>

<style scoped>
.toolbar {
  margin-bottom: 12px;
}
</style>
